function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// ----------------------------------------------------------------------------
// Product Form Web Component: iamAddToCartButton <iam-add-to-cart-button>
// Extends: iamFormElement
// ----------------------------------------------------------------------------
// Manage the state and behavior of the "Add to Cart" button in response to
// product form interactions.
// - Dynamically updates the button's text, availability, and loading states
//   based on product variant selection, quantity changes, form validation, and
//   the add-to-cart process.
// ----------------------------------------------------------------------------
// Event Listeners:
// - `productForm:variant:changed`    → Updates the button state when the variant changes
// - `productForm:quantity:changed`   → Updates the button state when the quantity changes
// - `productForm:validation:changed` → Disables the button if form validation fails,
//                                      regardless of variant availability
// - `productForm:submitting`         → Updates the button state to "Adding to Cart"
//                                      while the request is being processed
// - `productForm:submitted:success`  → Temporarily updates the button state to
//                                      "Added to Cart" after an item is successfully
//                                      added to the cart
// - `productForm:submitted:error`    → Updates the button state to an "Error" state
//                                      if the add-to-cart request fails. If the
//                                      error is due to the item being sold out,
//                                      the button state is set to "Sold Out", otherwise
//                                      it defaults to a generic error state.
// ----------------------------------------------------------------------------
// Gotchas:
// - Form validation can override button availability, keeping it disabled even
//   if a variant is available.
// - After a successful add-to-cart event, the button remains in the "Item Added"
//   state for ITEM_ADDED_DURATION (default 3 secs) before resetting.
// - If an unknown button state occurs, it defaults to a generic error state and
//   disables the button (until the variant selection changes).
// - Translation strings are defined in the `products.add_to_cart` namespace of
//   the locales file.
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Helpers
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import translate from 'scripts/helpers/iamota-translate';
import registerCustomElement from 'scripts/helpers/register-custom-element';
import iamFormElement from 'scripts/classes/iamFormElement';

// -------------------------------------
// Web Component
// -------------------------------------

class iamAddToCartButton extends iamFormElement {
  /**
   * Initialize the component when the product form is initialized
   */
  onFormInit() {
    // Bind event listeners
    iamotaEventHandler.subscribe('productForm:variant:changed', this.onVariantChange.bind(this), {
      context: this.iamForm,
      source: "add-to-cart-button.js"
    });
    iamotaEventHandler.subscribe('productForm:quantity:changed', this.onQuantityChange.bind(this), {
      context: this.iamForm,
      source: "add-to-cart-button.js"
    });
    iamotaEventHandler.subscribe('productForm:sellingPlan:changed', this.onSellingPlanChange.bind(this), {
      context: this.iamForm,
      source: "add-to-cart-button.js"
    });
    iamotaEventHandler.subscribe('productForm:validation:changed', this.onValidate.bind(this), {
      context: this.iamForm,
      source: "add-to-cart-button.js"
    });
    iamotaEventHandler.subscribe('productForm:submitting', this.onAdding.bind(this), {
      context: this.iamForm,
      source: "add-to-cart-button.js"
    });
    iamotaEventHandler.subscribe('productForm:submitted:success', this.onAddSuccess.bind(this), {
      context: this.iamForm,
      source: "add-to-cart-button.js"
    });
    iamotaEventHandler.subscribe('productForm:submitted:error', this.onAddError.bind(this), {
      context: this.iamForm,
      source: "add-to-cart-button.js"
    });

    // State
    this.state = iamAddToCartButton.BUTTON_STATES.LOADING;
    this.refreshState();
  }
  onValidate(_ref) {
    var {
      isValid
    } = _ref;
    if (isValid) {
      // Validation Passes -> refresh to match the current variant's state
      this.refreshState();
    } else {
      // Validation Fails -> disable the add-to-cart button
      this.setDisabled(true);
    }
  }
  onVariantChange(_ref2) {
    var {
      variant
    } = _ref2;
    this.refreshState(variant);
  }
  onQuantityChange(_ref3) {
    var {
      quantity
    } = _ref3;
    // If the qty changes, trigger a variant refresh
    // e.g. in case the copy includes the qty in the price
    this.refreshState();
  }
  onSellingPlanChange(_ref4) {
    var {
      sellingPlan
    } = _ref4;
    // If the selling plan changes, trigger a variant refresh
    // e.g. in case the copy includes the selling plan in the price

    this.refreshState();
  }

  /**
   * Handle form submission
   * @param {event} event
   */
  onAdding() {
    this.setState(iamAddToCartButton.BUTTON_STATES.ADDING_TO_CART);
  }
  onAddSuccess() {
    this.setState(iamAddToCartButton.BUTTON_STATES.ITEM_ADDED);
  }
  onAddError(_ref5) {
    var _error$description;
    var {
      error
    } = _ref5;
    if ((_error$description = error.description) !== null && _error$description !== void 0 && _error$description.includes('sold out')) {
      this.setState(iamAddToCartButton.BUTTON_STATES.SOLD_OUT);
    } else {
      this.setState(iamAddToCartButton.BUTTON_STATES.ERROR);
    }
  }

  /**
   * Refresh the button state based on the currently selected variant
   * @param {*} variant
   */
  refreshState() {
    var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.iamForm.getCurrentVariant();
    var sellingPlan = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.iamForm.getCurrentSellingPlan();
    if (!variant) {
      this.setState(iamAddToCartButton.BUTTON_STATES.UNAVAILABLE, variant);
    } else if (variant.available) {
      if (sellingPlan && sellingPlan.purchase_type == 'onetime' || sellingPlan == null) {
        this.setState(iamAddToCartButton.BUTTON_STATES.AVAILABLE, variant);
      } else {
        this.setState(iamAddToCartButton.BUTTON_STATES.AVAILABLE_SUBSCRIPTION, variant);
      }
    } else {
      this.setState(iamAddToCartButton.BUTTON_STATES.SOLD_OUT, variant);
    }
  }

  /**
   * Set the current state and update the UI accordingly
   */
  setState(newState) {
    this.state = newState;
    switch (this.state) {
      case iamAddToCartButton.BUTTON_STATES.UNAVAILABLE:
        // (i.e. this combination of variation options likely doesn't exist)
        this.updateButton({
          buttonText: translate('Unavailable', 'addToCart.unavailable', _objectSpread({}, this.iamForm.getCurrentData())),
          isDisabled: true
        });
        break;
      case iamAddToCartButton.BUTTON_STATES.AVAILABLE:
        // Check if the item is available for purchase
        this.updateButton({
          buttonText: translate('Add to cart', 'addToCart.available', _objectSpread({}, this.iamForm.getCurrentData())),
          isDisabled: false
        });
        break;
      case iamAddToCartButton.BUTTON_STATES.AVAILABLE_SUBSCRIPTION:
        // Check if the item is available for purchase
        this.updateButton({
          buttonText: translate('Add to cart & Subscribe', 'addToCart.available_subscription', _objectSpread({}, this.iamForm.getCurrentData())),
          isDisabled: false
        });
        break;
      case iamAddToCartButton.BUTTON_STATES.SOLD_OUT:
        // (i.e. likely sold out or discontinued)
        this.updateButton({
          buttonText: translate('Sold Out', 'addToCart.sold_out', _objectSpread({}, this.iamForm.getCurrentData())),
          isDisabled: true
        });
        break;
      case iamAddToCartButton.BUTTON_STATES.LOADING:
        this.updateButton({
          buttonText: translate('Loading...', 'addToCart.loading', _objectSpread({}, this.iamForm.getCurrentData())),
          isDisabled: true,
          isLoading: true
        });
        break;
      case iamAddToCartButton.BUTTON_STATES.ADDING_TO_CART:
        this.updateButton({
          buttonText: translate('Adding to cart...', 'addToCart.adding_to_cart', _objectSpread({}, this.iamForm.getCurrentData())),
          isDisabled: true,
          isLoading: true
        });
        break;
      case iamAddToCartButton.BUTTON_STATES.ITEM_ADDED:
        this.updateButton({
          buttonText: translate('Item added to cart', 'addToCart.item_added', _objectSpread({}, this.iamForm.getCurrentData())),
          isDisabled: true
        });
        setTimeout(() => {
          this.refreshState();
        }, iamAddToCartButton.ITEM_ADDED_DURATION);
        break;
      case iamAddToCartButton.BUTTON_STATES.ERROR:
        this.updateButton({
          buttonText: translate('Unable to add', 'addToCart.error', _objectSpread({}, this.iamForm.getCurrentData())),
          isDisabled: true
        });
        break;
      default:
        console.warn("Unknown add-to-cart-button state: ".concat(this.state));
        this.setState(iamAddToCartButton.BUTTON_STATES.ERROR);
        break;
    }
  }

  /**
   * Update button UI based on the provided options
   */
  updateButton(_ref6) {
    var {
      buttonText = this.control.innerHTML,
      isDisabled = false,
      isLoading = false
    } = _ref6;
    this.setText(buttonText);
    this.setLoading(isLoading);
    this.setDisabled(isDisabled, 'updateButton');
  }

  /**
   * Set the button text
   * @param {string} label
  */
  setText(buttonText) {
    var _this = this;
    return _asyncToGenerator(function* () {
      buttonText = yield iamotaEventHandler.applyFilters('productForm:addToCartButton:buttonText', buttonText, {
        context: _this.iamForm
      });
      _this.control.innerHTML = buttonText;
      _this.control.setAttribute('aria-label', buttonText);
    })();
  }

  /**
   * Disable the button
   * @param {boolean} isDisabled
   */
  setDisabled(isDisabled) {
    var _this$iamForm$validat;
    // Force disabled state if the form is invalid
    var isFormValid = (_this$iamForm$validat = this.iamForm.validator) === null || _this$iamForm$validat === void 0 ? void 0 : _this$iamForm$validat.isFormValid();
    var newState = isDisabled || !isFormValid;
    super.setDisabled(newState);
  }
}
_defineProperty(iamAddToCartButton, "ITEM_ADDED_DURATION", 3000);
// Duration to show "Item added" message (ms) before reverting to default state
_defineProperty(iamAddToCartButton, "BUTTON_STATES", {
  AVAILABLE: 'available',
  AVAILABLE_SUBSCRIPTION: 'available_subscription',
  UNAVAILABLE: 'unavailable',
  SOLD_OUT: 'sold_out',
  ITEM_ADDED: 'item_added',
  LOADING: 'loading',
  ADDING_TO_CART: 'adding_to_cart',
  ERROR_MAX_QUANTITY: 'error_max_quantity',
  ERROR: 'error_unknown'
});
registerCustomElement('iam-add-to-cart-button', iamAddToCartButton);